
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M14.445 11.885a16.632 16.632 0 1 1 4.258 28.43l-1.418 3.566a20.47 20.47 0 1 0-10.611-9.606l-.002.005a20.543 20.543 0 0 0 4.307 5.633c.33-.725.728-1.618 1.194-2.678.745-1.766 1.377-3.151 1.895-4.155.388-.746.753-1.373 1.094-1.883a9.978 9.978 0 0 1 1.239-1.494 4.756 4.756 0 0 1 1.676-1.093c.632-.243 1.337-.365 2.114-.365h3.386l-4.445 4.445 3.178 3.178 10.733-10.733L22.31 14.4l-3.178 3.178 4.445 4.445H20.19c-1.102 0-2.139.134-3.11.401-.971.268-1.834.608-2.587 1.02-.754.413-1.483.968-2.186 1.664a19.62 19.62 0 0 0-1.797 2.016c-.495.648-1.013 1.458-1.555 2.43l-.04.071a16.632 16.632 0 0 1 5.53-17.74Z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-outline",attrs:{"d":"M13.065 10.271a16.632 16.632 0 1 1 4.258 28.43l-1.419 3.566a20.47 20.47 0 1 0-10.61-9.606l-.003.005a20.544 20.544 0 0 0 4.307 5.633c.33-.725.728-1.618 1.194-2.678.746-1.766 1.377-3.15 1.895-4.155.389-.745.753-1.373 1.094-1.883a9.984 9.984 0 0 1 1.24-1.493 4.757 4.757 0 0 1 1.675-1.094c.633-.243 1.337-.365 2.114-.365h3.386l-4.445 4.445 3.178 3.178 10.733-10.733L20.93 12.788l-3.178 3.177 4.445 4.445H18.81c-1.101 0-2.138.134-3.11.402-.97.267-1.833.607-2.587 1.02-.753.412-1.482.967-2.186 1.664a19.628 19.628 0 0 0-1.797 2.016c-.494.647-1.013 1.457-1.555 2.43l-.04.07a16.631 16.631 0 0 1 5.53-17.74Z","stroke":"#234652"}})])
          )
        }
      }
    